<template>
  <div>
    <b-btn variant="link" @click="showOrder">Assign Course</b-btn>
    <c-modal
      centered
      size="lg"
      scrollable
      v-model="modal"
      no-close-on-esc
      no-close-on-backdrop
      title="Assign Course"
      :tag="false"
    >

      <template>
        <section style="min-height: 550px">
          <div>
            <section class="d-flex justify-content-between align-items-center">
              <b-button-group size="lg">
                <b-button @click="filterResult('all')" class="px-2" :class="filterStatus === 'all' ? 'activeBtn' : 'deactiveBtn'">
                  All
                </b-button>
                <b-button @click="filterResult('food')" class="px-2" :class="filterStatus === 'food' ? 'activeBtn' : 'deactiveBtn'">
                  Food
                </b-button>
                <b-button @click="filterResult('drink')" class="px-2" :class="filterStatus === 'drink' ? 'activeBtn' : 'deactiveBtn'">
                  Drink
                </b-button>
              </b-button-group>
              <span class="ml-2">
                Note: Course number cannot be changed for any item with "Served" status.
              </span>
<!--              <p class="text-danger mb-0 mt-4 font-weight-bold" v-if="order.Credit > 0">-->
<!--                This tab has applied credit and cannot be split by item.Remove tab credit to be able to split by item.-->
<!--              </p>-->
            </section>
            <section v-if="getData.length">
              <div class="my-4 border-bottom pb-4" v-for="item in getData">
                <b-row class="d-flex flex-row justify-content-between align-items-center">
                  <div class="d-flex col-6 align-items-center">
                  <span class="mr-4">
                    {{item.Quantity}}x
                  </span>
                    <div class="">
                      <p class="mb-0" :class="item.DrinkID ? 'alcoholicText' : 'text-dark'">
                    <span>
                      {{item.ItemName}}
                    </span>
                        <span class="font-weight-bold mx-3">${{(item.Price / item.Quantity).toFixed(2)}}</span>
                        <span v-if="item.Alcoholic" :class="item.Alcoholic ? 'alcoholicText' : 'text-dark'">
                        * ALC. VERIFY AGE *
                    </span>
                      </p>
                      <p v-if="item.PriceComment" class="mb-0 text-danger font-weight-bold">{{item.PriceComment}}</p>
                      <p v-if="item.Modifiers" style="color: red" class="mb-0">{{item.Modifiers}}</p>
                      <p v-if="item.Description" class="mb-0 text-danger font-weight-bold">{{item.Description}}</p>
                    </div>
                  </div>
                  <div class=" font-weight-bold" style="color:#f37021">
                    {{orderStatusText(item.OrderStatus)}}
                  </div>
                  <div class="pr-3">
                    <b-button-group size="sm">
                      <b-button :disabled="order.Credit > 0 || item.OrderStatus === 4 ? true : false" class="px-2" :variant="order.Credit > 0 ? 'secondary' : 'danger'" @click="subParty(item)">
                        <font-awesome-icon icon="minus" class="align-middle"/>
                      </b-button>
                      <span class="px-3 py-1" style="background: #f1f1f1">
                        Course {{item.party}}
                    </span>
                      <b-button :disabled="order.Credit > 0 || item.OrderStatus === 4 ? true : false" class="px-2" :variant="order.Credit > 0 ? 'secondary' : 'success'" @click="addParty(item)">
                        <font-awesome-icon icon="plus" class="align-middle"/>
                      </b-button>
                    </b-button-group>
                  </div>
                </b-row>
              </div>
            </section>
            <section class="py-3" v-else>
              No item available
            </section>
            <template>
              <section v-if="errorText" class="text-danger mb-4 font-weight-bold">
                Missing {{errorText}}. Assign item(s) to missing parties to proceed.
              </section>
            </template>
          </div>
        </section>
      </template>

      <template #actions>
        <b-row class="flex-grow-1">
          <b-col cols="12" md="4">
            <b-btn variant="warning" block class="text-nowrap mb-2 mb-md-0" :disabled="progressing" @click="submit">
              Save
              <font-awesome-icon v-if="progressing" spin icon="circle-notch" class="text-black align-middle mx-1"/>
            </b-btn>
          </b-col>
          <b-col cols="12" md="4">
            <b-btn variant="warning" block class="text-nowrap mb-2 mb-md-0" @click="sortData">
              Sort by Course Number
            </b-btn>
          </b-col>
          <b-col cols="12" md="4">
            <b-btn variant="danger" block class="text-nowrap cancel-btn-cmodal" @click="modal = false">
              Cancel
            </b-btn>
          </b-col>
        </b-row>
      </template>
      <confirmation-course v-model="confirmation" @assignCourse="setCourse" :progressing="progressing"/>
    </c-modal>
  </div>
</template>

<script>
    import NumericInput from "./NumericInput";
    import CModal from "./Cmodal";
    import ConfirmationCourse from "./confirmationCourse";
    export default {
        name: "assignCourse",
        components: {
            ConfirmationCourse,
            CModal,
            NumericInput
        },
        props: {
            orderId: {
                required: true, type: [String, Number]
            },
            order: {
                required: true
            }
        },
        data () {
            return {
                progressing: false,
                mode: 'item',
                errorText: '',
                modal: false,
                items: [],
                billSplit: [],
                disableSplit: false,
                filterStatus: 'all',
                splitAmount: 'equal',
                partyCount: 2,
                loading: false,
                availableParty: 2,
                disableItem: false,
                lastChar: 1,
                unequal: [
                    {
                        Party: 1,
                        NewSubtotal: 0
                    },
                    {
                        Party: 2,
                        NewSubtotal: 0
                    }
                ],
                paidParty: [],
                confirmation: false
            }
        },
        computed: {
            getData () {
                if (this.filterStatus === 'all') {
                    return this.billSplit
                }
                else if (this.filterStatus === 'food') {
                    return this.billSplit.filter(i => i.FoodID)
                } else {
                    return this.billSplit.filter(i => i.DrinkID)
                }
            },
            hasNewItem () {
                return this.billSplit.find(item => item.OrderStatus === 1)
            }
        },
        mounted () {
            console.log(this.order)
        },
        methods: {
            orderStatusText (status) {
                if (status === 1) return 'New'
                if (status === 2) return 'Confirmed'
                if (status === 3) return 'Ready'
                if (status === 4) return 'Served'
                if (status === 5) return 'Canceled'
                return ''
            },
            showOrder () {
                const model = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    // UserID: localStorage.getItem('userID'),
                    OrderID: this.orderId
                }
                Promise.all([
                    this.getOrderDetails(model),
                ]).then(res => {
                    res[0].forEach(item => {
                        if (!item.Course) {
                            this.$set(item, 'party', 1)
                        } else {
                            const split = item.Course.split('C')
                            this.$set(item, 'party', +split[1])
                        }
                    })
                    this.billSplit = res[0]
                    this.modal = true
                    // const countItems = res[0]
                    // const findOneItem = res[0].filter(i => i.Quantity === 1)
                    // if (countItems.length === 1 && findOneItem.length === 1) {
                    //     this.mode = 'amount'
                    //     this.disableItem = true
                    // } else {
                    //     if (this.order.SplitType === 'Amount') {
                    //         this.mode = 'amount'
                    //     } else if (this.order.SplitType === 'Item') {
                    //         this.mode = 'item'
                    //     } else {
                    //         this.mode = 'item'
                    //         this.disableItem = false
                    //     }
                    // }
                    // this.makeSplitData(res[0])
                })
            },
            getOrderDetails(model) {
                return this.$api.getRestaurant.GetRestaurantOrderDetail(model).then(res => {
                    if (res.success) {
                        return res.results.RestaurantOrderDetails
                    }
                }).catch(() => {

                })
            },
            makeSplitData (items) {
                const lastChar = this.order.TabNo.substr(this.order.TabNo.length - 1)
                this.lastChar = lastChar
                let split = []
                items.forEach(item => {
                    for (let i = 0; i < item.Quantity; i++) {
                        let newItem = {...item}
                        newItem.uId = Math.floor(Math.random() * 10000)
                        split.push(newItem)
                    }
                })
                split.forEach((item) => {
                    this.$set(item, 'party', lastChar)
                    this.$set(item, 'valid', true)
                })
                this.billSplit = split
                this.modal = true
            },
            addParty (item) {
                if (item.party < 20) {
                    item.party++
                    // if (item.party == this.lastChar) {
                    //     item.party = this.availableParty
                    //     this.$nextTick(() => {
                    //         this.sortTemporary()
                    //     })
                    // } else {
                    //     // paidParty
                    //     item.party = this.nextUnpaidParty(item.party)
                    //     this.$nextTick(() => {
                    //         this.sortTemporary()
                    //     })
                    // }
                }
            },
            nextUnpaidParty (value) {
                const nextVal = +value + 1
                if (!this.paidParty.find(item => item == nextVal)) return nextVal
                else return this.nextUnpaidParty(nextVal)
            },
            prevUnpaidParty (value) {
                const nextVal = +value - 1
                if (!this.paidParty.find(item => item == nextVal)) return nextVal
                else return this.prevUnpaidParty(nextVal)
            },
            subParty (item) {
                if (item.party > 1) {
                    item.party--
                }
                // if (item.party == this.availableParty) {
                //     item.party = this.lastChar
                //     this.$nextTick(() => {
                //         this.sortTemporary()
                //     })
                // } else {
                //     if (item.party > this.lastChar) {
                //         item.party = this.prevUnpaidParty(item.party)
                //         this.$nextTick(() => {
                //             this.sortTemporary()
                //         })
                //     }
                // }
            },


            sortTemporary () {
                const copy = this.billSplit.map(item => ({...item}))
                const sorted = copy.sort((a,b) => {
                    return b.party - a.party
                })
                sorted.forEach((item, index) => {
                    if (sorted[index + 1]) {
                        if (sorted[index].party - sorted[index + 1].party > 1) {
                            sorted[index + 1].valid = false
                        } else {
                            sorted[index + 1].valid = true
                        }
                    }
                })
                if (sorted.filter(i => !i.valid).length) {
                    this.disableSplit = true
                } else {
                    this.disableSplit = false
                }
                this.showUnUsedParty(sorted)
            },
            showUnUsedParty (sortedData) {
                const temp = sortedData.map(item => {
                    return item.party
                })
                const min = Math.min(...temp)
                const max = Math.max(...temp)
                let list = []
                for (var i = min; i <= max - 1; i++) {
                    if (i !== min && (!temp.find(item => item == i)) && i >= this.availableParty && (!this.paidParty.find(item => item == i))) {
                        list.push('Party ' + i);
                    }
                }
                this.errorText = list.join(' & ')
                // if (this.disableSplit) {
                //     const temp = sortedData.map(item => {
                //         return item.party
                //     })
                //     const min = Math.min(...temp)
                //     const max = Math.max(...temp)
                //     let list = []
                //     for (var i = min; i <= max - 1; i++) {
                //         if (i !== min && (!temp.find(item => item == i)) && i >= this.availableParty) {
                //             list.push('Party ' + i);
                //         }
                //     }
                //     this.errorText = list.join(' & ')
                // } else {
                //     this.errorText = ''
                // }
            },
            sortData () {
                this.billSplit = this.billSplit.sort((a,b) => {
                    return b.party - a.party
                })
            },
            filterResult (filterStatus) {
                this.filterStatus = filterStatus
            },
            submit() {
                if (this.hasNewItem) {
                    this.confirmation = true
                } else {
                    this.setCourse()
                }
            },
            setCourse () {
                const model = this.billSplit
                const body = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    // UserID: localStorage.getItem('userID'),
                    OrderID: this.orderId,
                    Items: model.map(item => {
                        return {
                            OrderDetailID: item.IKey,
                            CourseNo: 'C' + item.party
                        }
                    })
                }
                this.progressing = true
                return this.$api.getRestaurant.UpdateItemCourse(body).then(res => {
                    if (res.success) {
                        this.modal = false
                        this.$emit('refresh')
                    } else {
                        this.$showError(res.message)
                    }
                }).finally(() => {
                    this.progressing = false
                    this.confirmation = false
                })
            }
        }
    }
</script>

<style scoped>
  .activeBtn {
    background: #f5c31d !important;
    border-color: #c8ced3 !important;
    font-weight: bold;
  }
  .deactiveBtn {
    background: #fff !important;
    border-color: #c8ced3 !important;
    color: #c8ced3 !important;
    font-weight: bold;
  }
  .alcoholicText {
    color: #3d5afe;
  }
  .lightGreen{
    background: #b5e51f !important;
    color: #fff !important;
  }
</style>
